import { Component } from "react";

import "./style.scss";

class SwitchButton extends Component {

    state={
        active:false
    }

    toggleActive=()=>{
        this.setState({active:!this.state.active})
    }

    componentDidUpdate(){
        if(this.props.onChange) this.props.onChange(this.state.active);
    }

    render() {
        return (
            <div className={`switch-bt ${this.state.active ? "active" : ""} ${this.props.clean ? "clean" : ""}`} onClick={this.toggleActive}></div>
        )
    }
}

export default SwitchButton;